import axios from "axios";
import {HandleException} from "../exceptions/ExceptionHandler";
const baseURL = process.env.REACT_APP_KARAKTERBOOST_API_URL;

let accessToken = null;
let productId = null;
let productName = null;

export function setProductName(name) {
    if(name.includes("_")) {
        productName = name.replaceAll("_", " ");
    } else {
        productName = name;
    }
}

export function setAccessToken(token) {
    accessToken = token;
}

export function getAccessToken() {
    return accessToken;
}

export let apiClient = axios.create(
    {
        baseURL: baseURL + "api",
    }
)

apiClient.interceptors.request.use(async config => {
    const token = getAccessToken()
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    if (productId) {
        config.headers["X-PRODUCT-ID"] = productId;
    }
    if (productName) {
        config.headers["X-PRODUCT-NAME"] = productName;
    }
    return config;
},
    (error) => Promise.reject(error))



export async function getRequest(path, setErrorMessage, credentials = true) {
    try {
        const response = await apiClient.get(path, {
            withCredentials: credentials,
        })
        return response.data;
    } catch (error) {
        HandleException(error, setErrorMessage);
        throw error;
    }
}

export async function deleteRequest(client, path, setErrorMessage) {

    try {
        const response = await client.delete(path, {
            withCredentials: true
        })
        return response.data;
    } catch (error) {
        HandleException(error, setErrorMessage);
        throw error;
    }
}

export async function postRequest(path, setErrorMessage, body) {
    try {
        const response = await apiClient.post(path, body, {
            withCredentials: true
        })
        return response.data;
    } catch (error) {
        HandleException(error, setErrorMessage);
        throw error;
    }
}

export async function fetchWithRetry(fn, predicateFn, retries = 3, delay = 1000) {
    let attempts = 0;

    while (attempts < retries) {
        const response = await fn();
        if (predicateFn(response)) {
            return response;
        }

        attempts++;
        if (attempts < retries) {
            await new Promise(res => setTimeout(res, delay * attempts)); // optional backoff
        }
    }

    throw new Error("Too many retries");
}
